import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc007346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = ["id", "data-cy", "onClick"]
const _hoisted_3 = { class: "block lg:flex" }
const _hoisted_4 = {
  key: 0,
  class: "flex lg:flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_OfflineHint = _resolveComponent("OfflineHint")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "data-cy": "imageGalleryModal",
    title: $props.title,
    "hide-save": "",
    "go-back-mode": "",
    onClose: _cache[2] || (_cache[2] = () => $setup.cancel())
  }, {
    cta: _withCtx(() => [
      _createVNode(_component_ion_buttons, { class: "justify-end" }, {
        default: _withCtx(() => [
          ($props.onDelete && !$props.isReadonly && !$props.inSurveyMode)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                "data-cy": "button-delete-photo",
                title: _ctx.$t('hzba.buttons.tooltips.deleteImage'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.deleteImage($setup.selectedImage)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: $setup.trashOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          ($props.downloadEnabled && !$props.inSurveyMode)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                "data-cy": "downloadResource",
                title: _ctx.$t('hzba.buttons.tooltips.downloadImage'),
                onClick: _cache[1] || (_cache[1] = () => $setup.downloadResource($setup.selectedImage))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: $setup.canShare ? $setup.share : $setup.download
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          ($props.downloadEnabled && $props.inSurveyMode)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 2,
                "data-cy": "downloadResources",
                title: _ctx.$t('hzba.buttons.tooltips.downloadAllImages'),
                onClick: $setup.downloadResources
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: $setup.canShare ? $setup.share : $setup.download
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["title", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        ref: "content",
        "data-cy": "imageGalleryContent"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_OfflineHint, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('immobilie.images.offlineHint')), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imagesToDisplay, (photo, key) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `photo-${key}`,
                key: photo,
                class: "px-4 pt-4",
                "data-cy": `photo-${key}`,
                onClick: ($event: any) => ($setup.selectImage(photo))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_image, {
                    src: $setup.getPhotoUrl(photo),
                    "image-class": 'w-full h-auto',
                    "data-cy": `image-${key}`
                  }, null, 8, ["src", "data-cy"]),
                  ($props.inSurveyMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        ($props.onDelete && !$props.isReadonly)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              "data-cy": "button-delete-photo",
                              class: "lg:ml-2",
                              title: _ctx.$t('hzba.buttons.tooltips.deleteImage'),
                              onClick: ($event: any) => ($setup.deleteImage(photo))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.trashOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["title", "onClick"]))
                          : _createCommentVNode("", true),
                        ($props.downloadEnabled)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              class: "lg:ml-2",
                              title: _ctx.$t('hzba.buttons.tooltips.downloadImage'),
                              onClick: () => $setup.downloadResource(photo)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: $setup.canShare ? $setup.share : $setup.download
                                }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["title", "onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          class: "lg:ml-2",
                          title: _ctx.$t('hzba.buttons.tooltips.editImage'),
                          onClick: ($event: any) => ($setup.openImageEditorModal(photo))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: $setup.createSharp
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["title", "onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_2))
            }), 128))
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title"]))
}